export default __webpack_public_path__ + "static/media/UG.9f67137f.svg";